import styled from "styled-components"

export const Container = styled.div`
  color: #232627;
  display: flex;
  padding: 12px 20px;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #e8ecef;
`

export const Close = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  & svg path {
    fill: #6c7275;
  }
`
